import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const IconFilter = React.forwardRef<SVGSVGElement, any>((props, ref) => {
  return (<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon-filter" data-icon="icon-filter" aria-hidden="true" {...props} ref={ref}><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/></svg>);
});

IconFilter.displayName = 'IconFilter';
